import React from "react";
import Notification from "rc-notification";
import { isAbortError } from "../../util";
import NotificationItem from "./NotificationItem";
export default class Notificator {
    defaultDuration;
    _rcNotificationInstance;
    constructor(defaultDuration = 10) {
        this.defaultDuration = defaultDuration;
        Notification.newInstance({}, (n) => {
            this._rcNotificationInstance = n;
        });
    }
    success = (content, opts = {}) => {
        this.showNotification(opts.title ?? "Success!", content, false, opts.duration);
    };
    error = (error, opts = {}) => {
        if (isAbortError(error)) {
            return;
        }
        const _description = this.buildErrorDescription(error);
        this.showNotification(opts.title ?? "Error!", _description, true, opts.duration);
    };
    showNotification = (title, content, isError = false, duration) => {
        const key = Date.now().toString();
        const close = () => this.rcNotificationInstance.removeNotice(key);
        this.rcNotificationInstance.notice({
            key,
            content: (React.createElement(NotificationItem, { key: key, isError: isError, title: title, onClose: close }, content)),
            duration: duration ?? this.defaultDuration,
        });
    };
    buildErrorDescription = (error) => {
        if (typeof error === "string")
            return error;
        if (!error)
            return "";
        if (typeof error === "object") {
            if ("message" in error && typeof error.message === "string") {
                return error.message;
            }
            return React.isValidElement(error) ? error : JSON.stringify(error);
        }
        return String(error);
    };
    get rcNotificationInstance() {
        if (!this._rcNotificationInstance) {
            throw new Error("Notification instance is not initialized");
        }
        return this._rcNotificationInstance;
    }
}
//# sourceMappingURL=Notificator.js.map